var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ReminderModal } from '@ReactComponents/TransactionsPage/TransactionsModals/ReminderModal';
import { TransactionsApi } from '@ClientApi/transactionsApi';
import { ShowModal } from './modalActions';
export const SELECT_REIMBURSABLE_EXPENSE = 'SELECT_REIMBURSABLE_EXPENSE';
export const RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP = 'RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP';
export const RESET_REIMBURSABLE_EXPENSES = 'RESET_REIMBURSABLE_EXPENSES';
export const CLEAR_REIMBURSABLE_EXPENSE = 'CLEAR_REIMBURSABLE_EXPENSE';
export class ResetReimbursableExpensesLoadedTimestamp {
    constructor() {
        this.type = RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP;
    }
}
export class ResetReimbursableExpenses {
    constructor() {
        this.type = RESET_REIMBURSABLE_EXPENSES;
    }
}
export class SelectReimbursableExpense {
    constructor(payload) {
        this.payload = payload;
        this.type = SELECT_REIMBURSABLE_EXPENSE;
    }
}
export class ClearReimbursableExpense {
    constructor() {
        this.type = CLEAR_REIMBURSABLE_EXPENSE;
    }
}
export const approveReimbursableExpense = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.approve(expense.id);
});
export const denyReimbursableExpense = (expense, data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.deny(expense.id, data);
});
export const unapproveReimbursableExpense = (expense, data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.unapprove(expense.id, data);
});
export const deleteReimbursableExpense = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.deleteOne(expense.id);
});
export const openReminderModal = (userId) => {
    return new ShowModal(ReminderModal, {
        onSuccessfulReminder: () => { },
        userId
    });
};
export const clearReimbursableExpense = () => (dispatch) => {
    dispatch(new ClearReimbursableExpense());
};
